import React, { useEffect } from 'react';
import styled, { keyframes } from 'styled-components';
import { useNotification } from '../context/NotificationContext';

const Notification = () => {
  const { notification, dismissNotification } = useNotification();
  
  // Handle escape key to dismiss
  useEffect(() => {
    const handleEscKey = (event) => {
      if (event.key === 'Escape' && notification) {
        dismissNotification();
      }
    };
    
    window.addEventListener('keydown', handleEscKey);
    return () => window.removeEventListener('keydown', handleEscKey);
  }, [notification, dismissNotification]);
  
  if (!notification) return null;
  
  return (
    <NotificationContainer>
      <NotificationContent type={notification.type}>
        <NotificationMessage>{notification.message}</NotificationMessage>
        <CloseButton onClick={dismissNotification}>×</CloseButton>
      </NotificationContent>
    </NotificationContainer>
  );
};

// Animation for the notification
const slideIn = keyframes`
  from {
    transform: translateY(-100%);
    opacity: 0;
  }
  to {
    transform: translateY(0);
    opacity: 1;
  }
`;

const NotificationContainer = styled.div`
  position: fixed;
  top: 20px;
  left: 50%;
  transform: translateX(-50%);
  z-index: 99999; /* Extremely high z-index to ensure it's always on top */
  display: flex;
  justify-content: center;
  width: 100%;
  pointer-events: none;
  max-width: 500px;
`;

const NotificationContent = styled.div`
  background: ${props => props.type === 'error' ? '#FFEBEE' : '#E8F5E9'};
  color: ${props => props.type === 'error' ? '#C62828' : '#2E7D32'};
  border-left: 4px solid ${props => props.type === 'error' ? '#C62828' : '#2E7D32'};
  box-shadow: 0 8px 16px rgba(0, 0, 0, 0.2);
  padding: 16px 24px;
  border-radius: 8px;
  display: flex;
  align-items: center;
  width: 100%;
  pointer-events: auto;
  animation: ${slideIn} 0.4s ease-out forwards;
  font-family: 'Space Grotesk', sans-serif;
  transform-origin: top center;
`;

const NotificationMessage = styled.span`
  flex: 1;
  font-size: 16px;
  font-weight: 500;
`;

const CloseButton = styled.button`
  background: none;
  border: none;
  font-size: 22px;
  cursor: pointer;
  color: inherit;
  margin-left: 16px;
  padding: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  width: 24px;
  height: 24px;
  opacity: 0.7;
  transition: opacity 0.2s;
  
  &:hover {
    opacity: 1;
  }
`;

export default Notification; 